module.exports = __webpack_public_path__ + "static/media/808SwitchLabel--aiVariation.91b88b5c.svg";